import { render, staticRenderFns } from "./CookieConsent.vue?vue&type=template&id=32971f83&scoped=true&"
import script from "./CookieConsent.vue?vue&type=script&lang=js&"
export * from "./CookieConsent.vue?vue&type=script&lang=js&"
import style0 from "./CookieConsent.vue?vue&type=style&index=0&id=32971f83&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32971f83",
  null
  
)

export default component.exports